import Rub from '@shared/svg/rub.svg'
import Star from '@shared/svg/star.svg'

export const partnerFormSummary = [
	{
		Icon: Star,
		content: 'Упростите себе работу и предоставьте вашим клиентам удобный сервис.',
	},
	{
		Icon: Rub,
		content: 'Забудьте про «операционку», занимаясь развитием компании',
	},
]
